import { FC } from "react";
import { AddressOptionResource } from "../../../shared/types/address";
import { Address } from "../../../shared/ui/Address";

interface Props {
	addresses: AddressOptionResource[];
}

export const ContactAddressList: FC<Props> = ({ addresses }) => {
	return (
		<ul>
			{addresses.map((address, index) => (
				<li key={index}>
					<Address address={address} />
				</li>
			))}
		</ul>
	);
};
